import { render } from "./Settings.vue?vue&type=template&id=7479b459"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=7479b459&lang=css"

import exportComponent from "D:\\local_sites\\svn_sandra\\outside_sales_system\\apps\\sales_visits_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__